import { createSlice } from '@reduxjs/toolkit';
import { IError, IErrorsInitialStats } from './types';
import { storeResources } from '../resources';
import { RootState } from '../types';

const initialState: IErrorsInitialStats = {
  errors: [],
};

const errorsSlice = createSlice({
  name: storeResources.ERRORS,
  initialState,
  reducers: {
    addError: (state, action) => {
      state.errors.push({ ...action.payload, id: new Date().getTime() });
    },
    removeError: (state, action) => {
      state.errors = state.errors.filter(error => error.id !== action.payload);
    },
  },
});

export default errorsSlice.reducer;
export const { addError, removeError } = errorsSlice.actions;
export const ErrorsSelector = (state: RootState): IError[] => state[storeResources.ERRORS].errors;
